import { CSSProperties } from 'react';
import { useReduxState } from 'hooks';
import { getCourseLanguageVersionOptions } from 'lib/courses';
import { FlagIcon, Tooltip } from 'components/common';

import type { Course } from 'shared-types';

interface Props {
  course: Pick<Course, 'language' | 'languageVersions'>;
  onlyPublished: boolean;
  style?: CSSProperties;
}

const CourseLanguageVersionsFlags = ({
  course,
  onlyPublished,
  style
}: Props) => {
  const { messages } = useReduxState();

  const availableLanguages = getCourseLanguageVersionOptions({
    course,
    onlyPublished
  });

  if (Object.keys(availableLanguages).length <= 1) return null;

  return (
    <div className="flags" style={style}>
      <span className="sr-only">
        {`${messages.courseLanguageVersionsAvailable}: `}
      </span>
      {Object.entries(availableLanguages).map(([language, languageObject]) => (
        <Tooltip
          childrenWrapInDiv={false}
          content={languageObject.capitalizedName}
          key={language}
        >
          <div className="flag" key={language}>
            <FlagIcon lang={language} size="small" />
          </div>
        </Tooltip>
      ))}

      <style jsx>{`
        .flags {
          display: flex;
          gap: 5px;
        }
      `}</style>
    </div>
  );
};

export default CourseLanguageVersionsFlags;
